<template>
  <div>
    <other-banner :BannerType="'招贤纳士'"></other-banner>
    <div class="content_box">
      <div class="title">
        <title-nav :zhName="$route.name" :enName="$route.meta.cate"></title-nav>
      </div>
      <div class="cutr_content">
        <div
          class="in_for_tan animate__animated animate__slow"
          :class="{ active_intro: item.check, animate__fadeInUp: item.anmintes }"
          @click="ChangPop(item)"
          v-for="(item, index) in recruitList"
          :key="index"
        >
          <div class="foy_item">
            <div class="img_box">
              <div class="names line-text--three" :title="item.title">
                {{ item.title }}
              </div>
              <div class="txt_lines"></div>
            </div>
            <div class="lines"></div>
            <div class="intro">
              <div class="tips">岗位信息：</div>
              <div class="intro_mess tbs">所属公司：{{ item.company }}</div>
              <div class="intro_mess tbs">工作地点：{{ item.address }}</div>
              <div class="intro_mess tbs">发布时间：{{ item.create_time }}</div>
              <div class="intro_mess tbs">招聘人数：{{ item.number }}名</div>
              <div class="info_box">
                <div class="tips">岗位职责：</div>
                <div class="intro_mess tbs">{{ item.duty }}</div>
                <div class="tips">岗位要求：</div>
                <div class="intro_mess tbs">{{ item.requirement }}</div>
                <div class="conus">
                  如您符合岗位要求，请在前程无忧招聘网站上投递简历，或咨询招聘热线：{{
                    config.recruit_tel
                  }}
                </div>
              </div>
            </div>
            <div class="see">
              <img
                v-if="item.check"
                class="active_img"
                src="../assets/product/active_op.png"
              />
              <img v-else class="img" src="../assets/product/see.png" />
            </div>
          </div>
        </div>
        <div class="block_pagination block_pc" v-if="total">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="5"
            :pager-count="7"
            layout="prev, pager, next, total,jumper"
            :total="total"
          >
          </el-pagination>
        </div>
        <div class="block_pagination block_wap" v-if="total">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="5"
            :pager-count="5"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OtherBanner from "../components/otherBanner";
import TitleNav from "../components/titleNav";
import { getConfig, getRecruitList } from "../api/apis";

export default {
  name: "product",
  components: { TitleNav, OtherBanner },
  data() {
    return {
      recruitList: [],
      total: 0,
      page: 1,
      config: {},
    };
  },
  mounted() {
    this.GetRecruitList();
    this.GetConfig();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (document.body.clientWidth < 1200) {
      } else {
        if (scroll > 135) {
          if (this.recruitList[0]) {
            this.recruitList[0].anmintes = true;
          }
        }
        if (scroll > 384) {
          if (this.recruitList[1]) {
            this.recruitList[1].anmintes = true;
          }
        }
        if (scroll > 638) {
          if (this.recruitList[2]) {
            this.recruitList[2].anmintes = true;
          }
        }
        if (scroll > 890) {
          if (this.recruitList[3]) {
            this.recruitList[3].anmintes = true;
          }
        }
        if (scroll > 1136) {
          if (this.recruitList[4]) {
            this.recruitList[4].anmintes = true;
          }
        }
        if (scroll > 1384) {
          if (this.recruitList[5]) {
            this.recruitList[5].anmintes = true;
          }
        }
      }
      //   this.showNowBtn = true;
      // }
      // if (scroll > 4000) {
      //   this.showSurvey = true;
      // }
      // if (document.body.clientWidth < 1200) {
      //   if (scroll > 2300) {
      //     this.showSurvey = true;
      //   }
      // }
    },
    handleCurrentChange(e) {
      this.page = e;
      this.GetRecruitList();
    },
    ChangPop(e) {
      e.check = !e.check;
    },
    GetConfig() {
      getConfig().then((res) => {
        this.config = res.data;
      });
    },
    GetRecruitList() {
      let datas = { page: this.page, limit: 5 };
      getRecruitList(datas).then((res) => {
        res.data.data.map((item) => {
          item.check = false;
          item.anmintes = false;
        });
        this.recruitList = res.data.data;
        this.total = res.data.total;
      });
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  width: 1200px;
  margin: 0 auto;
  cursor: pointer;
  .title {
    margin: 100px auto 30px;
  }
  .cutr_content {
    margin-top: 30px;

    .in_for_tan {
      opacity: 0;
      max-height: 190px;
      background: #f3f3f3;
      margin-bottom: 30px;
      transition: all 0.3s linear;
      overflow: hidden;
      position: relative;
      .foy_item {
        padding: 34px 29px 17px;
        display: flex;

        .img_box {
          max-width: 30%;
          .names {
            width: 60px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          .txt_lines {
            width: 24px;
            height: 0px;
            border: 2px solid #333333;
            margin: 29px 0 19px;
          }
        }

        .lines {
          width: 0px;
          height: 64px;
          border: 1px solid #707070;
          opacity: 1;
          margin: 0 50px 0 36px;
        }

        .intro {
          transition: all 0.3s linear;
          .tips {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 28px;
            color: #333333;
            margin-bottom: 15px;
          }

          .intro_mess {
            width: 596px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            line-height: 22px;
            color: #666666;
            -webkit-line-clamp: 2;
            white-space: pre-wrap;
          }

          .conus {
            margin-top: 83px;
            margin-bottom: 31px;
            width: 728px;
            height: 45px;
            background: #0092dd;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            line-height: 45px;
            text-align: center;
            color: #ffffff;
          }

          .tbs {
            margin-bottom: 5px;
          }
        }
        .see {
          position: absolute;
          right: 39px;
          bottom: 24px;
          display: flex;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
            margin-right: 15px;
          }

          .img {
          }

          .active_img {
            width: 30px;
            height: 7px;
          }
        }
      }
    }
    .active_intro {
      max-height: 9999px;
    }
    .in_for_tan:hover {
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
    }
    .block_wap {
      display: none;
    }

    .block_pc {
      display: block;
      margin: 80px auto 160px;
    }
  }
}
@media (max-width: 1200px) {
  .content_box {
    width: auto;
    padding: 0.1px 15px 0;
    .title {
      margin: 26px auto 11px;
    }
    .cutr_content {
      margin-top: 20px;
      .in_for_tan {
        opacity: 1;
        max-height: 111px;
        overflow: hidden;
        background: #f3f3f3;
        margin-bottom: 30px;
        transition: all 0.3s linear;
        position: relative;
        .foy_item {
          padding: 10px 13px 19px;
          display: flex;

          .img_box {
            .names {
              font-size: 15px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            .txt_lines {
              width: 12px;
              height: 0px;
              border: 1px solid #333333;
              margin: 9px 0 5px;
            }
          }
          .lines {
            width: 0px;
            height: 32px;
            border: 1px solid #707070;
            opacity: 1;
            margin: 0 13px 0 16px;
          }

          .intro {
            .names {
              font-size: 15px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            .txt_lines {
              width: 12px;
              height: 0px;
              border: 1px solid #333333;
              margin: 9px 0 5px;
            }

            .tips {
              font-size: 13px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 14px;
              color: #333333;
              margin-bottom: 7px;
            }

            .intro_mess {
              width: 191px;
              font-size: 13px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              line-height: 15px;
              color: #666666;
              -webkit-line-clamp: 2;
              white-space: pre-wrap;
            }

            .tbs {
              margin-bottom: 5px;
            }
            .info_box {
              height: auto;
              margin-left: -90px;
              width: auto;
              .intro_mess {
                width: 100%;
              }
            }
            .conus {
              margin-top: 53px;
              margin-bottom: 15px;
              width: auto;
              height: auto;
              line-height: 15px;
              padding: 10px 0;
              background: #0092dd;
              font-size: 11px;
              font-family: Microsoft YaHei;
              font-weight: 300;
              text-align: center;
              color: #ffffff;
              word-break: break-word;
              white-space: normal;
            }
          }

          .see {
            position: absolute;
            right: 10px;
            bottom: 19px;
            display: flex;
            align-items: center;
            img {
              width: 11px;
              height: 11px;
              margin-right: 4px;
            }
            .img {
              display: inline-block;
              transform: translateY(12px);
            }

            .active_img {
              width: 11px;
              height: 3px;
            }
          }
        }
      }
      .active_intro {
        max-height: 999px;
      }
      .in_for_tan:hover {
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
      }
      .block_wap {
        display: block;
        margin: 35px auto 70px;
      }

      .block_pc {
        display: none;
      }
    }
  }
}
</style>
